module.exports = __webpack_public_path__ + "static/media/404.767d094d.svg";